export default "__VITE_ASSET__BrXtWiUi__"